import React, {useState, useEffect} from 'react';
import {MultipleChoice, ProgressBar, LandscapeModal, AboutQuizModal} from '../components';
import {useAnime} from "../utils/hooks";
import {useStoreState, useStoreActions} from "easy-peasy";
import {useContentful, getQuestionWithId} from '../utils';
import {getQueryString} from '../utils/queryParsing';

const Quiz = ({questionIndex}) => {
    const data         = useContentful();
    const currentId    = useStoreState(state => state.question.currentId);
    const modalDisplay = useStoreState(state => state.aboutModal.current);
    const turnOffModal = useStoreActions(actions => actions.aboutModal.turnOffModal);

    const [isLandscape, setIsLandscape] = useState(Math.abs(window.orientation) === 90);

    useAnime({
        targets  : `.quiz-container`,
        opacity  : data ? 1 : 0,
        duration : 500,
        delay    : 50,
        easing   : `linear`
    });

    const screenOrientation = e => {
        setIsLandscape(Math.abs(window.orientation) === 90);
    };

    useEffect(() => {
        window.scrollTo(0, 0);
        document.querySelector(`.iframe-scroll-container`).scrollTop = 0;
    }, []);

    window.addEventListener(`orientationchange`, screenOrientation);

    const question = data ? getQuestionWithId(data, currentId) : null;

    if (questionIndex === 1 || questionIndex === 3) {
        turnOffModal();
    }

    return (
        <section className="quiz-container" style={{opacity: 0}} aria-labelledby={`header_${questionIndex}`}>
            {data && (
                <>
                    <LandscapeModal display={isLandscape}/>
                    <MultipleChoice questionIndex={questionIndex} data={question} />
                    <AboutQuizModal display={modalDisplay && getQueryString() !== `` && questionIndex === 2} />
                    <ProgressBar questionIndex={questionIndex} />
                </>
            )}
        </section>
    );
};

export default Quiz;
